import { ADD_INDICATION } from './actionTypes';

const addIndication = indication => ({ type: ADD_INDICATION, payload: indication });

export default addIndication;
